import {EVENT_PREFIX} from '../../../helpers';

export default (input) => ({
  ...{
    type: `${EVENT_PREFIX}_META_INIT`
  },
  ...input
});
